// ----------------------------------------------------------------------
// Campaign Management Translations - English
// ----------------------------------------------------------------------

export const campaignEn = {
  campaign: {
    title: 'Campaign Tracking',
    subtitle: 'Create UTM-tracked links to monitor your social media campaigns',
    activeCampaigns: 'active',
    createNew: 'Create Campaign',
    viewDetails: 'View Details',
    hideDetails: 'Hide Details',
    urlCopied: 'Tracking link copied to clipboard',
    utmParameters: 'UTM Parameters',
    defaultMedium: 'Default medium',

    // Create Form
    create: {
      title: 'Create New Campaign',
      description: 'Generate a unique tracking link for your social media campaign',
      submit: 'Create Campaign',
    },

    // Form Fields
    field: {
      name: 'Campaign Name',
      namePlaceholder: 'e.g., Summer Party Instagram Promo',
      nameHelp: 'A descriptive name for your campaign',
      description: 'Description',
      descriptionPlaceholder: 'Brief description of your campaign...',
      platform: 'Platform',
      contentType: 'Content Type',
      trackingUrl: 'Tracking URL',
      budget: 'Budget',
      targetClicks: 'Target Clicks',
      targetConversions: 'Target Conversions',
      notes: 'Notes',
      notesPlaceholder: 'Additional notes about this campaign...',
      tags: 'Tags',
      tagsPlaceholder: 'summer, promo, instagram',
      tagsHelp: 'Comma-separated tags for organizing campaigns',
    },

    // Content Types
    contentType: {
      post: 'Post',
      story: 'Story',
      reel: 'Reel',
      video: 'Video',
      carousel: 'Carousel',
      ad: 'Ad',
      email: 'Email',
      sms: 'SMS',
      live: 'Live',
      other: 'Other',
    },

    // Statuses
    status: {
      draft: 'Draft',
      active: 'Active',
      paused: 'Paused',
      completed: 'Completed',
      archived: 'Archived',
    },

    // Table Headers
    table: {
      campaign: 'Campaign',
      platform: 'Platform',
      status: 'Status',
      clicks: 'Clicks',
      conversions: 'Conversions',
      revenue: 'Revenue',
      conversionRate: 'Conv. Rate',
      actions: 'Actions',
    },

    // Actions
    action: {
      copyLink: 'Copy Tracking Link',
      edit: 'Edit',
      activate: 'Activate',
      pause: 'Pause',
      resume: 'Resume',
      complete: 'Mark Complete',
      delete: 'Delete',
    },
    actions: 'Actions',

    // Tabs
    tab: {
      campaigns: 'Campaigns',
      analytics: 'Analytics',
    },

    // Empty State
    empty: {
      title: 'No campaigns yet',
      description: 'Create your first campaign to start tracking your social media performance',
      cta: 'Create Your First Campaign',
    },

    // Validation
    validation: {
      nameMin: 'Campaign name must be at least 3 characters',
      nameMax: 'Campaign name must be less than 100 characters',
      nameRequired: 'Campaign name is required',
      descriptionMax: 'Description must be less than 500 characters',
      platformRequired: 'Platform is required',
      contentTypeRequired: 'Content type is required',
    },

    // Success Messages
    success: {
      created: 'Campaign created successfully',
      updated: 'Campaign updated successfully',
      deleted: 'Campaign deleted successfully',
      statusUpdated: 'Campaign status updated',
    },

    // Error Messages
    error: {
      createFailed: 'Failed to create campaign',
      updateFailed: 'Failed to update campaign',
      deleteFailed: 'Failed to delete campaign',
      statusUpdateFailed: 'Failed to update campaign status',
      loadFailed: 'Failed to load campaigns',
    },

    // Analytics
    analytics: {
      error: 'Failed to load campaign analytics',
      totalCampaigns: 'Total Campaigns',
      active: 'active',
      totalClicks: 'Total Clicks',
      uniqueVisitors: 'unique visitors',
      totalConversions: 'Conversions',
      conversionRate: 'conversion rate',
      totalRevenue: 'Total Revenue',
      platformPerformance: 'Performance by Platform',
      contentTypePerformance: 'Performance by Content Type',
      topCampaigns: 'Top Performing Campaigns',
      campaigns: 'campaigns',
      clicks: 'Clicks',
      conversions: 'Conversions',
      conv: 'Conv.',
      revenue: 'Revenue',
    },
  },
};

export default campaignEn;
